import { render, staticRenderFns } from "./pendingrequest.vue?vue&type=template&id=68a1476b"
import script from "./pendingrequest.vue?vue&type=script&lang=js"
export * from "./pendingrequest.vue?vue&type=script&lang=js"
import style0 from "./pendingrequest.vue?vue&type=style&index=0&id=68a1476b&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports